import PERMISSIONS from '@/constants/permissions';

export const SKILLS_ACCESS = {
  view: [PERMISSIONS.Skills.VIEW, PERMISSIONS.Skills.MANAGE, PERMISSIONS.BUSINESS_PARTNER],
  manage: [PERMISSIONS.Skills.MANAGE, PERMISSIONS.BUSINESS_PARTNER],
};
